<template>
  <v-list-tile
    :to="to"
    :active-class="color"
    avatar
    class="v-list-item"
  >
    <v-list-tile-action>
      <v-icon v-if="icon">{{ icon }}</v-icon>
    </v-list-tile-action>

     <div  style="font-size: 14px !important;font-weight: 300;padding: 5px 0px 5px 0px">
        <v-badge v-if="badge"
            color="red"
            right>
            {{text}}
          <template slot="badge">
            <span>{{badge}}</span>
          </template>
        </v-badge>
      </div>

    <v-list-tile-title v-text="text" v-if="!badge"/>
    
  </v-list-tile>
</template>

<script>
import { mapMutations, mapState } from "vuex";

export default {
    props:['to', 'active-class', 'text', 'icon', 'badge'],
    computed: {
        ...mapState("app", ["image", "color"])
    }
};
</script>

<style>
</style>